module.exports = __webpack_public_path__ + "img/identity.eb2e7ac8.png";